/** Sign-out is outside React, but uses the same action and invalidation as the call window. */
import { queryClient } from '../../../lib/query-client';
import { moderationActions } from './hooks';
import type { EndPrivateChatVars } from './types';

export async function endPrivateChatAtSignOut(input: EndPrivateChatVars): Promise<void> {
  const action = moderationActions(queryClient).endPrivateChat;
  await action.mutationFn(input);
  action.onSuccess();
}
